import AntSlider from "antd/es/slider";
import styled, { css } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import { SliderRangeProps } from "antd/es/slider";

const StyledSlider = ({ ...props }: SliderRangeProps) => {
  return <Slider {...props} />;
};

export default StyledSlider;

const Slider = styled(AntSlider)`
  .ant-slider-mark-text {
    color: ${(p) => p.theme.colors.textColor};
  }
  .ant-slider-track {
    background-color: ${(p) => p.theme.colors.primaryBlue};
    &:not(.ant-tooltip-open) {
      background: ${(p) => p.theme.colors.primaryBlue}!important;
    }
  }
  .ant-slider-handle {
    border-color: ${(p) => p.theme.colors.primaryBlue};
    &:not(.ant-tooltip-open) {
      border-color: ${(p) => p.theme.colors.primaryBlue}!important;
    }
  }
  .ant-slider-dot-active {
    background-color: ${(p) => p.theme.colors.primaryBlue};
    border: none;
    width: 10px;
    height: 10px;
    top: -3px;
  }
  &.ant-slider-with-marks {
    margin-bottom: 0 !important;
  }
  .ant-slider-rail {
    background-color: ${(p) => p.theme.colors.mediumBorderGrey}!important;
  }
  .ant-slider-dot:not(.ant-slider-dot-active) {
    border-color: ${(p) => p.theme.colors.mediumBorderGrey}!important;
    background-color: ${(p) => p.theme.colors.cardBgColor}!important;
  }
  .ant-slider-handle::after {
    box-shadow: 0 0 0 2px ${(p) => p.theme.colors.primaryBlue}!important;
  }
  .ant-slider-handle:hover::after {
    box-shadow: 0 0 0 4px ${(p) => p.theme.colors.primaryBlue}!important;
  }
  .ant-slider-handle::after {
    background: ${(p) => p.theme.colors.cardBgColor}!important;
  }
  ${(p) => p.theme.isNewLook && newLookSliderStyles}
`;

// New look: a slim rail, hollow dots that fill in along the track, a soft
// halo (not a thicker ring) on hover/drag, and quiet mark labels.
const newLookSliderStyles = css`
  .ant-slider-rail {
    background-color: ${(p) => p.theme.colors.lightBorderGrey}!important;
  }
  .ant-slider-rail,
  .ant-slider-track {
    border-radius: 999px;
  }
  .ant-slider-dot,
  .ant-slider-dot-active {
    width: 8px;
    height: 8px;
    border-width: 2px;
    border-style: solid;
  }
  .ant-slider-dot-active {
    background-color: ${(p) => p.theme.colors.cardBgColor};
    border-color: ${(p) => p.theme.colors.primaryBlue};
  }
  .ant-slider-handle::after {
    box-shadow: 0 0 0 2px ${(p) => p.theme.colors.primaryBlue},
      0 1px 3px ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.35)} !important;
  }
  .ant-slider-handle:hover::after,
  .ant-slider-handle:focus::after,
  .ant-slider-handle-dragging::after {
    box-shadow: 0 0 0 2px ${(p) => p.theme.colors.primaryBlue},
      0 0 0 6px ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.14)} !important;
  }
  .ant-slider-mark-text {
    color: ${(p) => p.theme.colors.secondaryText};
    font-variant-numeric: tabular-nums;
  }
  .ant-slider-mark-text-active {
    color: ${(p) => p.theme.colors.primaryText};
  }
`;
